import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modal__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_ctx.$props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal__overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }),
        _createElementVNode("div", {
          class: "modal__dialog",
          style: _normalizeStyle({ maxWidth: _ctx.$props.maxWidth || '440px' })
        }, [
          _createElementVNode("img", {
            src: "/img/close-btn.svg",
            class: "modal__close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "content")
          ]),
          (_ctx.$props.visibleFooter)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["modal__footer", { 'modal__footer--center': !_ctx.$props.visibleCancelBtn }])
              }, [
                (_ctx.$props.visibleCancelBtn)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "modal__button modal__button--outline",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                    }, [
                      _createVNode(_component_i18n_t, {
                        keypath: _ctx.$props.cancelButtonText
                      }, null, 8, ["keypath"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$props.submitButtonIsRed)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "modal__button modal__button--red",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                    }, [
                      _createVNode(_component_i18n_t, {
                        keypath: _ctx.$props.submitButtonText
                      }, null, 8, ["keypath"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "modal__button modal__button--blue",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                    }, [
                      _createVNode(_component_i18n_t, {
                        keypath: _ctx.$props.submitButtonText
                      }, null, 8, ["keypath"])
                    ]))
              ], 2))
            : _createCommentVNode("", true)
        ], 4)
      ]))
    : _createCommentVNode("", true)
}